//import {initLightslider} from "./custom/lightslider";
//import {initCssEvents} from "./custom/cssEvents";

import M from './materialize-css-without-autocomplete/dist/js/materialize';

$(function () {

	//M.AutoInit();
	M.Dropdown.init(document.querySelectorAll('.dropdown-trigger'), {
		constrainWidth: false,
		alignment     : 'top',
	});

	M.Sidenav.init(document.querySelectorAll('.sidenav'), {
		edge: "right"
	});

	$("body").on("click", '.varianty li input', function () {
		let li = $(this).parents("li");
		if ($(this).is(":selected")) {
			li.addClass('selected');
		} else {
			li.removeClass('selected');
		}
	});

	$('.showMoreInfo').click(function () {
		$('.descriptionCategory').css('height', 'auto');
		$(this).hide();
		$(".showLessInfo").css('display', 'block');
	});

	$('.showLessInfo').click(function () {
		$('.descriptionCategory').css('height', '58px');
		$(this).hide();
		$(".showMoreInfo").show();
	});


	$('#js-search-button-show').click(function () {
		$('form').addClass('show');
		$('.menu-items').toggleClass('hidden');
		$('#frm-formSearch-search').focus();
	});
	$('#js-search-button-hide').click(function () {
		$('.menu-items').toggleClass('hidden');
		$('form').removeClass('show');
	});
	$(".fancybox").fancybox();

});

// konfigurace výstupu autocomplete
function anyShopAutocompleteRenderItem(name, typeId, typeName, image) {
	if (typeName == 'položka') {
		return "<a><span class='acimg'><img src='" + absoluteUrl + "/soubory/product/male/" + image + "' /></span>" + name + "</a>";
	} else if (typeName == 'kategorie') {
		return "<a>" + name + " <small class='" + typeId + "' >(" + typeName + ")</small></a>";
	} else {
		return "<a>" + name + " <small class='" + typeId + "' >(" + typeName + ")</small></a>";
	}
}
